import React, { Component } from "react";
import "./HTimeline.css";
import TimelineVis from "./HTimelineVis.js";
import { withFirebase } from "../Firebase";
import { withAuthorization } from "../Session";
import { useParams } from "react-router-dom";

// Get ID from Route Slug
// Note: useParams is a hook from Router v5.1
// you can only use useParams under a function
export default function UserTimeline() {
  let params = useParams();
  console.log("------ I'm in UserTimeline() ------");
  return <HTimelineAuthed timelineID={params.slug}></HTimelineAuthed>;
}

class HTimelineBase extends Component {
  state = {
    timelineID: null,
    timelineName: "",
    loading: false,
    timelineEvents: [],
    numChildren: 1,
    isAdding: false,
    isEditMode: false,
  };

  getNow = () => {
    const nowEvent = new Date();
    const dateString = nowEvent.toLocaleDateString();
    return {
      title: "Now",
      time: dateString,
      description: "This is now",
      isEditMode: false,
    };
  };

  // Add event to firebase
  onSubmitEventEntry = (event) => {
    event.preventDefault();

    // Get title input
    const eventTitle = event.target[0].value;
    const eventDescription = event.target[1].value;
    const eventTime = event.target[2].value;

    const newEvent = {
      title: eventTitle,
      time: eventTime,
      description: eventDescription,
      isEditMode: false,
    };

    this.state.timelineEvents.push(newEvent);

    this.setState({
      isAdding: false,
      numChildren: this.state.numChildren + 1,
    });

    var uid = this.props.firebase.auth.currentUser.uid;

    // user ID:
    //  event ID:
    //   event:
    this.props.firebase.timelineEvent(uid).push({
      ...newEvent,
    });

    this.props.firebase.timelineEventTid(uid, this.state.timelineID).push({
      ...newEvent,
    });
  };

  // TODO: remove a specific event
  onRemoveEvent = (uid, tid, eid) => {
    this.props.firebase.timelineEventTid(uid, tid, eid).remove();
  };

  // TODO: do an onEditEvent here
  onEditEvent = (uid, tid) => {
    // update an entry
  };

  componentDidMount() {
    var tid = this.props.timelineID;
    console.log("TID:", tid);

    var uid = this.props.firebase.auth.currentUser.uid;
    console.log("UID:", uid);

    this.setState({ loading: true, timelineID: tid });

    // Only grabbing events from this timeline
    this.props.firebase.timelineEventTid(uid, tid).on("value", (snapshot) => {
      const timelineEventsObject = snapshot.val();

      if (timelineEventsObject) {
        const timelineEventsList = Object.keys(timelineEventsObject).map(
          (key) => ({
            ...timelineEventsObject[key],
            uid: key,
          })
        );

        timelineEventsList.push(this.getNow());

        console.log("Events object to event list-", timelineEventsList);
        this.setState({
          timelineEvents: timelineEventsList,
          loading: false,
        });
      } else {
        console.log("There's no event in timelineEvents");
        this.setState({
          loading: false,
        });
      }
    });

    this.props.firebase.timelines(uid).on("value", (snapshot) => {
      const timelinesObject = snapshot.val();
      this.setState({ timelineName: timelinesObject[tid].title });

      console.log("this.state.timelineName: ", this.state.timelineName);
    });
  }

  componentWillUnmount() {
    this.props.firebase.timelineEvents().off();
    this.props.firebase.timelineEventTid().off();
    this.props.firebase.timelineEvent().off();
  }

  render() {
    return (
      <div>
        <div className="content-wrapper ">
          <h1 className="header-title">
            <h6>{this.state.loading && <div>Loading ...</div>}</h6>
            <br />
            {this.state.timelineName}
          </h1>
        </div>

        {/* Event input boxes */}
        <div className="form-wrapper" style={{ display: "none" }}>
          <EventBox
            timelineEvents={this.state.timelineEvents}
            onSubmitEventEntry={this.onSubmitEventEntry}
            id={this.state.numChildren}
            key={this.state.numChildren}
          />
        </div>

        {/* Event display boxes - D3 */}
        <div className="timeline-wrapper">
          <TimelineVis timelineEvents={this.state.timelineEvents} />
        </div>
      </div>
    );
  }
}

class EventBox extends Component {
  state = {
    title: "",
    time: "",
    description: "",
  };

  handleTitleChange = (event) => {
    this.setState({ title: event.target.value });
    event.preventDefault();
  };

  handleTimeChange = (event) => {
    this.setState({ time: event.target.value });
    event.preventDefault();
  };

  handleDescriptionChange = (event) => {
    this.setState({ description: event.target.value });
    event.preventDefault();
  };

  render() {
    const index = this.props.id + 1;
    return (
      /* TODO: make timeForm position more dynamic */
      <div id={index} key={index} className={"timeForm"}>
        <form onSubmit={(e) => this.props.onSubmitEventEntry(e, index)}>
          <div className="formTitle">event Title</div>
          <input
            type="text"
            name="title"
            onChange={this.handleTitleChange}
            value={this.state.title}
            autoComplete="off"
            className="event-input input-title"
          />

          <div className="formTitle">event detail</div>
          <textarea
            type="text"
            name="description"
            onChange={this.handleDescriptionChange}
            value={this.state.description}
            className="event-input input-description"
          />

          <div className="formTitle">event time</div>
          <input
            type="date"
            name="time"
            value={this.state.time}
            onChange={this.handleTimeChange}
            className="event-input input-time"
            placeholder=""
          />
          <button type="submit" className="btn-submit">
            Add event to timeline
          </button>
        </form>
      </div>
    );
  }
}

const HTimeline = withFirebase(HTimelineBase);
const condition = (authUser) => !!authUser;

const HTimelineAuthed = withAuthorization(condition)(HTimeline);
